import React from 'react';
import { Link } from 'react-router-dom';
import styles from './UnauthorizedPage.module.css';

const UnauthorizedPage = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>403</h1>
            <p className={styles.message}>Access Denied</p>
            <p>You do not have permission to view this page.</p>
            <Link to="/" className={styles.homeLink}>Go to Homepage</Link>
        </div>
    );
};

export default UnauthorizedPage;
